import { LABEL } from '@veriables';

const ROW_BTN_BG = 'rgb(116, 164, 255)';
const ROW_BTN_BG_SEND = 'rgb(37, 65, 164)';

export const ROW_ACTIONS_BY_TAB = {
  pending: [
    { key: 'move', name: LABEL().MOVE, bg: ROW_BTN_BG },
    { key: 'repeat', name: LABEL().REPEAT, bg: ROW_BTN_BG },
    { key: 'edit', name: LABEL().MODIFY, bg: ROW_BTN_BG },
    { key: 'delete', name: LABEL().DELETE, bg: ROW_BTN_BG },
    { key: 'send', name: LABEL().SEND, bg: ROW_BTN_BG_SEND },
  ],
  sent: [
    { key: 'move', name: LABEL().MOVE, bg: ROW_BTN_BG },
    { key: 'repeat', name: LABEL().REPEAT, bg: ROW_BTN_BG },
    { key: 'refill', name: LABEL().REFILL, bg: ROW_BTN_BG },
  ],
};

export const BULK_ACTIONS = {
  pendingEmpty: [
    { key: 'deleteAll', name: LABEL().DELETE_ALL },
    { key: 'sendAll', name: LABEL().SEND_ALL },
  ],
  pendingSelected: [
    { key: 'move', name: LABEL().MOVE },
    { key: 'repeat', name: LABEL().REPEAT },
    { key: 'deleteSelected', name: LABEL().DELETE },
    { key: 'hold', name: LABEL().HOLD},
    { key: 'sendSelected', name: LABEL().SEND },
  ],
};
